import React from 'react'

import { BusTicket, Car, CarTime, FlightTicket, Hotels, Internet, TravelInsurance, Gsm, GiftCard, Finance } from '@enuygun/icons'

import * as S from './ServiceCards.styled'

export const serviceCardData = [
  {
    icon: (
      <S.FlightSvg>
        <FlightTicket width={20} height={20} style={{ marginTop: '6px' }} />
      </S.FlightSvg>
    ),
    title: 'Uçak Bileti',
    href: 'https://www.enuygun.com/ucak-bileti/',
  },
  {
    icon: (
      <S.HotelSvg>
        <Hotels width={20} height={20} style={{ marginTop: '4px' }} />
      </S.HotelSvg>
    ),
    title: 'Otel',
    href: 'https://www.enuygun.com/otel/',
  },
  {
    icon: (
      <S.BusSvg>
        <BusTicket width={20} height={20} style={{ marginTop: '6px' }} />
      </S.BusSvg>
    ),
    title: 'Otobüs',
    href: 'https://www.enuygun.com/otobus-bileti/',
  },
  {
    icon: (
      <S.CarSvg>
        <Car width={20} height={20} style={{ marginTop: '11px' }} />
      </S.CarSvg>
    ),
    title: 'Araç Kiralama',
    href: 'https://www.enuygun.com/arac-kiralama/',
  },
  {
    icon: (
      <S.CarTimeSvg>
        <CarTime width={20} height={20} style={{ marginTop: '6px' }} />
      </S.CarTimeSvg>
    ),
    title: 'Transfer',
    href: 'https://www.enuygun.com/transfer/',
  },
  {
    icon: (
      <S.TravelInsuranceSvg>
        <TravelInsurance width={20} height={20} style={{ marginTop: '7px' }} />
      </S.TravelInsuranceSvg>
    ),
    title: 'Sigorta',
    href: 'https://www.enuygunsigorta.com/',
  },
  {
    icon: (
      <S.FinanceSvg>
        <Finance width={20} height={20} style={{ marginTop: '7px' }} />
      </S.FinanceSvg>
    ),
    title: 'Finans',
    href: 'https://www.enuygunfinans.com/',
  },
  {
    icon: (
      <S.InternetSvg>
        <Internet width={20} height={20} style={{ marginTop: '8px' }} />
      </S.InternetSvg>
    ),
    title: 'İnternet',
    href: 'https://www.enuygun.com/internet-baglantilari/?ref=enuygun-anasayfa-metromenu',
  },
  {
    icon: (
      <S.GiftCardSvg>
        <GiftCard width={22} height={22} style={{ marginTop: '5px' }} />
      </S.GiftCardSvg>
    ),
    title: 'Hediye Kart',
    href: 'https://www.enuygun.com/enuygun-hediye-kart/',
  },
  {
    icon: (
      <S.GsmSvg>
        <Gsm width={20} height={20} style={{ marginTop: '7px' }} />
      </S.GsmSvg>
    ),
    title: 'GSM',
    href: 'https://www.enuygun.com/gsm/',
  },
]
